
import {defineComponent, inject} from "vue";
import ItemDetailWork from "modules/construction-work/components/modal/ItemDetailWork.vue";
import SwiperBigGalleryWidget from '@app/modules/widget/swiper/big-gallery';
import {Store} from "modules/construction-work/src/Store";
import {
    ConstructionWorkDetailCardMapInterface,
    IncidentDetailCardMapIncident
} from "modules/construction-work/src/Common/interface";

export default defineComponent({
    name: "ModalWork",
    components: {
        ItemDetailWork
    },
    props: {
        isFullScreenMap: {
            type: Boolean,
            default: false
        }
    },
    expose: ["showSelectedWork"],
    methods: {
        getListAllSelectedWorks(): (IncidentDetailCardMapIncident|ConstructionWorkDetailCardMapInterface)[] {
            return [...this.store.cardDetailConstructionWorks, ...this.store.cardDetailIncidents];
        },
        getWorkCount(): number {
            return this.store.cardDetailConstructionWorks?.length + this.store.cardDetailIncidents?.length;
        },
        pluralWord(count: number, word: Array<string>) {
            let cases = [2, 0, 1, 1, 1, 2];
            return word[(count % 100 > 4 && count % 100 < 20) ? 2 : cases[Math.min(count % 10, 5)]];
        },
    },
    async mounted() {
        await this.$nextTick(function () {
            const optionsSlider = {
                allowTouchMove: true,
            };
            new SwiperBigGalleryWidget({
                options: optionsSlider,
                classSlider: '.js-swiper-detail-work',
                pagination: {
                    el: ".swiper-pagination",
                    type: "bullets",
                },
            }).init();
        });
    },
    setup() {
        const store = inject<Store>("store");
        return {
            store
        }
    }
})
